import { motion } from "framer-motion";
import poster from "../assets/images/Events/apresMenu.png";

const ChristmasWeek1 = () => {
  const snowflakes = Array.from({ length: 40 });

  return (
    <section
      className="
      relative 
      min-h-screen
      overflow-hidden
      py-32
      bg-gradient-to-b
      from-[#6fa8c9]
      via-[#183758]
      to-[#071522]
      "
    >
      {/* Snow texture */}
      <div
        className="
        absolute inset-0
        opacity-20
        bg-[radial-gradient(circle,#fff_1px,transparent_1px)]
        bg-[length:25px_25px]
        "
      />

      {/* Animated snowfall */}
      {snowflakes.map((_, i) => (
        <motion.div
          key={i}
          className="
          absolute
          text-white
          opacity-70
          "
          style={{
            left: `${Math.random() * 100}%`,
            top: `-${Math.random() * 20}%`,
            fontSize: `${Math.random() * 12 + 8}px`,
          }}
          animate={{
            y: ["0vh", "120vh"],
            rotate: [0, 360],
          }}
          transition={{
            duration: Math.random() * 10 + 10,
            repeat: Infinity,
            delay: Math.random() * 5,
          }}
        >
          ❄
        </motion.div>
      ))}

      {/* Mountain glow */}
      <div
        className="
        absolute
        bottom-0
        left-0
        right-0
        h-72
        bg-gradient-to-t
        from-black/60
        to-transparent
        "
      />


      {/* Heading */}
      <motion.div
        initial={{
          opacity:0,
          y:-80
        }}
        whileInView={{
          opacity:1,
          y:0
        }}
        exit={{
          opacity:0,
          y:-80
        }}
        viewport={{
          amount:0.3
        }}
        transition={{
          duration:1
        }}
        className="
        relative
        z-10
        text-center
        mb-24
        "
      >

        <p
          className="
          tracking-[12px]
          uppercase
          text-red-300
          font-semibold
          "
        >
          The Fox Inn Presents
        </p>


        <h2
          className="
          mt-5
          text-6xl
          md:text-8xl
          font-serif
          text-white
          drop-shadow-xl
          "
        >
          Après Ski
        </h2>


        <p
          className="
          mt-4
          text-xl
          uppercase
          tracking-[8px]
          text-white/80
          "
        >
          Social Club
        </p>


        <div
          className="
          mt-8
          text-white
          font-serif
          text-3xl
          "
        >
          4th & 5th December
        </div>

      </motion.div>



      <motion.div
        initial={{
          opacity:0,
          scale:.95
        }}
        whileInView={{
          opacity:1,
          scale:1
        }}
        viewport={{
          amount:.25
        }}
        transition={{
          duration:1
        }}
        className="
        relative
        z-10
        max-w-7xl
        mx-auto
        grid
        lg:grid-cols-2
        gap-20
        px-6
        items-center
        "
      >


        {/* Poster */}
        <motion.div
          initial={{
            x:-150,
            opacity:0
          }}
          whileInView={{
            x:0,
            opacity:1
          }}
          viewport={{
            amount:.3
          }}
          transition={{
            duration:1
          }}
          whileHover={{
            rotateY:8,
            scale:1.03
          }}
          className="
          perspective-1000
          "
        >

          <img
            src={poster}
            alt="Après Ski"
            className="
            rounded-2xl
            shadow-[0_30px_80px_rgba(0,0,0,.5)]
            border
            border-white/20
            "
          />

        </motion.div>

        {/* Details card */}
        <motion.div
        initial={{
            x: 150,
            opacity: 0
        }}
        whileInView={{
            x: 0,
            opacity: 1
        }}
        viewport={{
            amount: 0.3
        }}
        transition={{
            duration: 1,
            delay: 0.2
        }}
        className="
            backdrop-blur-xl
            bg-white/10
            border
            border-white/20
            rounded-3xl
            p-8
            shadow-2xl
        "
        >

        <h3
            className="
            text-4xl
            md:text-5xl
            font-serif
            text-red-400
            "
        >
            Après Ski
        </h3>

        <h4
            className="
            text-2xl
            text-white
            font-serif
            mt-1
            "
        >
            Winter Social Club
        </h4>

        <p
            className="
            mt-6
            text-white/90
            text-base
            leading-7
            "
        >
            Escape to the mountains without leaving The Fox.
            Join us for an alpine-inspired Christmas celebration
            filled with festive drinks, winter food and après ski
            atmosphere.
        </p>


        <div
            className="
            mt-8
            space-y-4
            text-white/90
            "
        >

            <p className="border-b border-white/10 pb-3">
            Mulled wine or spiced cider on arrival
            </p>

            <p className="border-b border-white/10 pb-3">
            Festive sweet and savoury street food selection
            </p>

            <p className="border-b border-white/10 pb-3">
            Alpine lodge atmosphere and winter-inspired décor
            </p>

            <p>
            Christmas lights and a magical festive setting
            </p>

        </div>


        <motion.p
            initial={{
            opacity: 0,
            y: 10
            }}
            whileInView={{
            opacity: 1,
            y: 0
            }}
            transition={{
            duration: 0.5
            }}
            className="
            mt-8
            text-center
            text-3xl
            font-bold
            text-red-300
            "
        >
            £10 Per Person
        </motion.p>


        <div className="flex gap-4 justify-center">
            <motion.a
                href="https://www.skiddle.com/e/42610208"
                whileHover={{
                scale: 1.05
                }}
                whileTap={{
                scale: 0.95
                }}
                className="
                inline-block
                mt-8
                px-10
                py-3
                rounded-full
                bg-red-500
                text-white
                font-semibold
                shadow-xl
                hover:bg-red-600
                transition
                "
            >
                4th December →
            </motion.a>
            <motion.a
                href="https://www.skiddle.com/e/42610209"
                whileHover={{
                scale: 1.05
                }}
                whileTap={{
                scale: 0.95
                }}
                className="
                inline-block
                mt-8
                px-10
                py-3
                rounded-full
                bg-red-500
                text-white
                font-semibold
                shadow-xl
                hover:bg-red-600
                transition
                "
            >
                5th December →
            </motion.a>
        </div>

        </motion.div>

      </motion.div>


    </section>
  );
};


export default ChristmasWeek1;